module.exports = __webpack_public_path__ + "img/Delowe Station Concepts_Page_1.2552e8d5.jpg";